import { ActionPlanItem } from '@/infra/api/generated/model'

export const getScoreIconColor = (score?: number | null, isOnBrand?: boolean) => {
  if (score === undefined || score === null) return 'text-neutral-400'

  if (isOnBrand) {
    if (score < 50) return 'text-red-500'
    if (score < 85) return 'text-yellow-400'
    return 'text-content-on-media-accent'
  }

  if (score < 50) return 'text-status-negative'
  if (score < 85) return 'text-status-warning'
  return 'text-status-positive'
}

export const calculateNewScore = (actions: ActionPlanItem[]) => {
  const validActions = actions.filter((action) => !action.isCustom)
  const completedCount = validActions.filter((action) => action.done).length
  const totalCount = validActions.length
  return totalCount === 0 ? 100 : Math.round((completedCount / totalCount) * 100)
}

export const calculateImprovedScore = (actionPlanScore: number, diagnosisScore: number) => {
  return Math.round(diagnosisScore + ((100 - diagnosisScore) * actionPlanScore) / 100)
}
